import { ChartRoleDatum } from './RolesDonutChart.tsx'

interface RolesLegendProps {
  items: ChartRoleDatum[]
}

const RolesLegend = ({ items }: RolesLegendProps) => {
  if (items.length === 0) {
    return null
  }

  const sortedItems = [...items].sort((a, b) => b.value - a.value)

  return (
    <ul className="flex flex-col gap-3 text-sm text-gray-700">
      {sortedItems.map((item) => (
        <li key={item.name} className="w-full">
          <div className="flex w-full items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
            <div className="flex min-w-0 flex-1 items-center gap-2">
              <span
                aria-hidden="true"
                className="h-2.5 w-2.5 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="truncate" title={item.name}>
                {item.name}
              </span>
            </div>
            <span className="ml-3 shrink-0 font-semibold text-gray-900">
              {item.value}
            </span>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default RolesLegend
